export default "__VITE_ASSET__pTjGwwTW__"